import { Divider, List, PillSkeleton, TextSkeleton } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

export function CreateShiftVerificationRequestSkeleton() {
  return (
    <>
      <Stack spacing={10} px={5} pb={4} aria-label="Loading shift verification request form">
        <TextSkeleton variant="h6" width="60%" />

        {/* Time inputs skeleton */}
        <List>
          <Stack spacing={6}>
            <Stack direction="row" spacing={2} alignItems="center">
              <TextSkeleton variant="h5" width="75%" />
              <PillSkeleton width={50} height={30} sx={{ flexGrow: 1 }} />
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
              <TextSkeleton variant="h5" width="75%" />
              <PillSkeleton width={50} height={30} sx={{ flexGrow: 1 }} />
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
              <TextSkeleton variant="h5" width="75%" />
              <PillSkeleton width={50} height={30} sx={{ flexGrow: 1 }} />
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
              <TextSkeleton variant="h5" width="75%" />
              <PillSkeleton width={50} height={30} sx={{ flexGrow: 1 }} />
            </Stack>
            <Divider />
            <Stack direction="row" spacing={30} alignItems="center" width="100%">
              <TextSkeleton variant="h3" width="30%" />
              <Box flexGrow={1} />
              <TextSkeleton variant="h1" width="30%" />
            </Stack>
          </Stack>
        </List>
      </Stack>

      {/* Reason & signature skeleton */}
      <Stack
        spacing={3}
        px={4}
        py={8}
        sx={{ backgroundColor: (theme) => theme.palette.background.primary }}
      >
        <TextSkeleton variant="h6" width="40%" />
        <TextSkeleton variant="body1" width="90%" />
        <PillSkeleton height={120} width="100%" />
        <TextSkeleton variant="body2" width="95%" />
        <PillSkeleton height={120} width="100%" />
      </Stack>
    </>
  );
}
